import { Component, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { TaxTypeEnums } from 'src/app/enum/tax-type-enums';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoiceCashReceiptRetentionTableModal } from 'src/app/models/tables/wallet/invoice-cash-receipt-retention-table-modal';
import { TaxTableModalModel } from 'src/app/models/tables/wallet/tax-table-modal.model';
import { InvoiceCashReceiptRetentionModel } from 'src/app/models/wallet/invoice-cash-receipt-retention.model';
import { TaxService } from 'src/app/services/management/tax.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { InvoiceCashReceiptRetentionService } from 'src/app/services/wallet/invoice-cash-receipt-retention.service';
import Swal from 'sweetalert2';

@Component({
  selector: '',
  templateUrl: './invoice-cash-receipt-retention-modal.component.html',
  styleUrls: ['./invoice-cash-receipt-retention-modal.component.scss'],
  standalone: false
})
export class InvoiceCashReceiptRetentionModalComponent implements OnInit {

  @ViewChild('taxSelection') taxSelectionModalComponent?: CustomModalComponent | null = null;

  ascendant: boolean = true;
  ascendantTax: boolean = true;
  changeRetentions: boolean = false;
  codeNameTax: string = '';
  columnSort: string | null = null;
  columnSortTax: string | null = null;
  dataTax: PagedResponseModel<TaxTableModalModel> = new PagedResponseModel<TaxTableModalModel>();
  disabledForm: boolean = false;
  filtersTax: ColumnResponseModel[] = [];
  formInvoiceCashReceiptRetention: FormGroup = new FormGroup({});
  headers: ColumnResponseModel[] = [];
  headersTax: ColumnResponseModel[] = [];
  inputsForTaxesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: false,
    filters: [],
  });
  invoiceCashReceiptId: number = 0;
  invoiceCashReceiptRetentionModel: InvoiceCashReceiptRetentionModel = new InvoiceCashReceiptRetentionModel();
  limit: number = 10;
  limitTax: number = 10;
  minimumBase: number = 0;
  output$ = new Subject<any>();
  page: number = 1;
  pageTax: number = 1;
  permissionUpdatable: boolean = true;
  suscription: Subscription;
  tableActions: TableAction[] = [];
  taxData: PagedResponseModel<InvoiceCashReceiptRetentionTableModal> = new PagedResponseModel<InvoiceCashReceiptRetentionTableModal>();
  taxId: number = 0;
  taxTotalValue: number = 0;
  taxType: string = '';
  taxTypeId: number = 0;
  componentTableSelection = CustomTableSelectComponent;

  constructor(public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private invoiceCashReceiptRetentionService: InvoiceCashReceiptRetentionService,
    private taxService: TaxService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm(this.invoiceCashReceiptRetentionModel);
  }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.invoiceCashReceiptId = inputs.invoiceCashReceiptId;
      this.permissionUpdatable = inputs.permissionUpdatable;
      this.disabledForm = inputs.disabledForm;
      this.validateForm(this.invoiceCashReceiptRetentionModel);
      this.tableActions = this.getDefaultActions();
    });
    this.suscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeTax(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
    await this.getColumns();
    await this.getAllRetentionsModalWithPagination();
  }

  close() {
    const data: ModalObjectType = {};
    if (this.changeRetentions) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  async getAllRetentionsModalWithPagination() {
    try {
      this.taxData = await firstValueFrom(this.invoiceCashReceiptRetentionService.getAllRetentionsModalWithPaginationAsync(
        this.page, this.limit, this.columnSort, this.ascendant, this.invoiceCashReceiptId
      ));
    } catch (error) {
      console.error('Error al obtener las Retenciones.', error);
    }
  }

  async getColumns() {
    try {
      this.headers = await firstValueFrom(this.invoiceCashReceiptRetentionService.getColumnsForModalConsultation());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getColumnsTax() {
    try {
      if (this.headersTax.length === 0) {
        this.headersTax = await firstValueFrom(this.taxService.getColumnsForTaxes());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para los impuestos.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    if (this.disabledForm) {
      return [];
    } else {
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          action: 'edit'
        },
        {
          label: 'Eliminar',
          icon: 'pi pi-trash',
          action: 'delete'
        }
      ];
    }
  }

  async getInvoiceCashReceiptRetentionByKeys() {
    if (this.invoiceCashReceiptId !== 0 && this.taxId !== 0) {
      try {
        this.invoiceCashReceiptRetentionModel = await firstValueFrom(
          this.invoiceCashReceiptRetentionService.GetInvoiceCashReceiptRetentionByKeys(this.invoiceCashReceiptId, this.taxId)
        );
        this.validateForm(this.invoiceCashReceiptRetentionModel);
      } catch (error) {
        this.invoiceCashReceiptRetentionModel = new InvoiceCashReceiptRetentionModel();
        this.invoiceCashReceiptRetentionModel.taxId = this.taxId;
        this.validateForm(this.invoiceCashReceiptRetentionModel);
        console.error('Error al consultar la Retención por Claves.', error);
      }
    }
  }

  async getTax(taxId: number | null, reload: boolean) {
    if (taxId != null && taxId !== 0) {
      this.taxId = taxId;
      const tax = await firstValueFrom(this.taxService.getTaxAndTypeById(taxId));
      if (tax) {
        this.codeNameTax = tax.tax;
        this.taxType = tax.type;
        this.taxTypeId = tax.taxTypeId;
        this.minimumBase = tax.minimumBase;
        this.formInvoiceCashReceiptRetention.controls.rate.patchValue(tax.rate);
      } else {
        this.codeNameTax = '';
        this.taxType = '';
        this.taxTypeId = 0;
        this.minimumBase = 0;
        this.formInvoiceCashReceiptRetention.controls.rate.patchValue(0);
      }
    } else {
      this.taxId = 0;
      this.codeNameTax = '';
      this.taxType = '';
      this.taxTypeId = 0;
      this.minimumBase = 0;
      this.formInvoiceCashReceiptRetention.controls.rate.patchValue(0);
    }

    if (reload) {
      await this.getInvoiceCashReceiptRetentionByKeys();
      this.getTaxTotalValue();
    }
  }

  getTaxTotalValue() {
    const base: number = this.formInvoiceCashReceiptRetention.get("base")?.value;
    const rate: number = this.formInvoiceCashReceiptRetention.get("rate")?.value;
    const dividends = this.taxTypeId == TaxTypeEnums.ica ? 1000 : 100;

    //Calculo el vr total del artículo
    this.taxTotalValue = ((base * rate) / dividends).toFixed(0) as unknown as number;
  }

  async getTaxesForInvoiceCashReceipt() {
    try {
      this.dataTax = await firstValueFrom(
        this.taxService.getTaxesForModal(this.pageTax, this.limitTax, this.columnSortTax, this.ascendantTax, this.filtersTax)
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los impuestos', error);
    }
  }

  async handleSelectedItem(selectedItem: any) {
    if (selectedItem && selectedItem.length === 1) {
      const taxId = parseInt(selectedItem[0]?.taxId);
      this.getTax(taxId, true);
    }
  }

  newRetention() {
    this.invoiceCashReceiptRetentionModel = new InvoiceCashReceiptRetentionModel();
    this.validateForm(this.invoiceCashReceiptRetentionModel);
    this.taxId = 0;
    this.codeNameTax = '';
    this.taxType = '';
    this.taxTypeId = 0;
    this.minimumBase = 0;
    this.taxTotalValue = 0;
  }

  async onAction(event: { action: string, item?: InvoiceCashReceiptRetentionTableModal, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      const canUpdate = await this.validatePermissionUpdatable();
      if (!canUpdate) return;
      try {
        this.invoiceCashReceiptRetentionModel = await firstValueFrom(this.invoiceCashReceiptRetentionService.getInvoiceCashReceiptRetentionById(event.item.id));
        this.getTax(this.invoiceCashReceiptRetentionModel.taxId, false);
        this.validateForm(this.invoiceCashReceiptRetentionModel);
      } catch (error) {
        console.error('Error al consultar la Retención por Id.', error);
      }
    }
    if (event.action === 'delete' && event.item) {
      const canUpdate = await this.validatePermissionUpdatable();
      if (!canUpdate) return;

      const result = await Swal.fire({
        title: 'Atención',
        text: "¿Realmente desea eliminar el Impuesto?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      });
      if (result.isConfirmed) {
        try {
          await firstValueFrom(this.invoiceCashReceiptRetentionService.deleteInvoiceCashReceiptRetention(event.item.id));
          this.toastHandlerService.showToast(
            'success',
            'El Impuesto fue eliminado exitosamente.'
          );
          this.changeRetentions = true;
          this.getAllRetentionsModalWithPagination();
        } catch (error) {
          console.error('Error al eliminar el Impuesto.', error);
        }
      }
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersTax = this.removeDuplicates(filters);
    this.filtersTax.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChange(event: { page: number; pageSize: number; sortField: string | undefined; sortOrder: number; }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getAllRetentionsModalWithPagination();
  }

  async onPageChangeTax(event: { page: number; pageSize: number; sortField: string | undefined; sortOrder: number; }) {
    this.pageTax = event.page;
    this.limitTax = event.pageSize;
    this.columnSortTax = event.sortField || null;
    this.ascendantTax = event.sortOrder === 1;
    this.getTaxesForInvoiceCashReceipt();
  }

  async openTaxSelectionModal() {
    if (this.disabledForm) {
      this.toastHandlerService.showToast(
        'warning',
        'No se pueden modificar los impuestos en un recibo de caja cerrado.'
      );
      return;
    }
    this.filtersTax = [];
    this.updateInputs();
    await Promise.all([
      await this.getColumnsTax(),
      this.getTaxesForInvoiceCashReceipt(),
    ]);

    if (this.taxSelectionModalComponent && this.headersTax) {
      this.taxSelectionModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'error',
        'No se pudieron cargar los impuestos. Por favor, inténtelo de nuevo.'
      );
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (
      valueFilter === null ||
      valueFilter === undefined ||
      valueFilter === '' ||
      valueFilter === 0
    ) {
      this.filtersTax = this.filtersTax.filter(
        (f) => f.propertyName !== propertyName
      );
    } else {
      const existingFilter = this.filtersTax.find(
        (f) => f.propertyName === propertyName
      );
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter(
      (value, index, self) =>
        index ===
        self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    Object.keys(this.formInvoiceCashReceiptRetention.controls).forEach(key => {
      const control = this.formInvoiceCashReceiptRetention.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formInvoiceCashReceiptRetention.valid) {
      const modelInvoiceCashReceiptRetention = this.formInvoiceCashReceiptRetention.getRawValue() as InvoiceCashReceiptRetentionModel;
      //Asigno la clave de la Factura
      modelInvoiceCashReceiptRetention.invoiceCashReceiptId = this.invoiceCashReceiptId;

      if (this.invoiceCashReceiptRetentionModel.invoiceCashReceiptRetentionId == 0) {
        try {
          await firstValueFrom(this.invoiceCashReceiptRetentionService.createInvoiceCashReceiptRetention(modelInvoiceCashReceiptRetention));
          this.toastHandlerService.showToast(
            'success',
            'La retención fue creada exitosamente.'
          );
          this.changeRetentions = true;
          this.getAllRetentionsModalWithPagination();
          this.newRetention();
        } catch (error) {
          console.error('Error al crear la retención:', error);
        }
      } else {
        this.invoiceCashReceiptRetentionModel.rate = modelInvoiceCashReceiptRetention.rate;
        this.invoiceCashReceiptRetentionModel.base = modelInvoiceCashReceiptRetention.base;

        try {
          await firstValueFrom(this.invoiceCashReceiptRetentionService.updateInvoiceCashReceiptRetention(this.invoiceCashReceiptRetentionModel));
          this.toastHandlerService.showToast(
            'success',
            'La retención fue modificada exitosamente.'
          );
          this.changeRetentions = true;
          this.getAllRetentionsModalWithPagination();
          this.newRetention();
        } catch (error) {
          console.error('Error al modificar la retención:', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      taxId: {
        required: 'El Id del impuesto es obligatorio.',
        min: 'El Id del impuesto debe ser mayor o igual a 1.'
      },
      base: {
        required: 'El campo Base es obligatorio.',
        min: 'La Base debe ser mayor o igual a 1.'
      },
      rate: {
        required: 'El campo Tarifa es obligatorio.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formInvoiceCashReceiptRetention.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateInputs() {
    this.inputsForTaxesSelection$.next({
      headers: this.headersTax,
      data: this.dataTax,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      filters: this.filtersTax,
    });
  }

  validateForm(invoiceCashReceiptRetentionModel: InvoiceCashReceiptRetentionModel) {
    this.formInvoiceCashReceiptRetention = this.formBuilder.group({
      taxId: [invoiceCashReceiptRetentionModel.taxId, [Validators.required, Validators.min(1)]],
      base: [invoiceCashReceiptRetentionModel.base, [Validators.required, Validators.min(1)]],
      rate: [invoiceCashReceiptRetentionModel.rate, [Validators.required]]
    });
    this.formInvoiceCashReceiptRetention.controls.rate.disable();
    if (invoiceCashReceiptRetentionModel.invoiceCashReceiptRetentionId !== 0) {
      this.getTaxTotalValue();
    }
    if (this.disabledForm) {
      this.formInvoiceCashReceiptRetention.disable()
    }
  }

  async validatePermissionUpdatable(): Promise<boolean> {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para modificar recibos de caja. Comuníquese con el administrador del sistema.'
      );
      return false;
    }
    return true;
  }

}
